import { createUpserter } from '@/app/shared/utils'
import { AnswerQuestionTrackingCommand } from '../api';
import { QuestionState, defaultQuestionState } from './question-state';

type QuestionsState = QuestionState[];
export type QuestionCommand = AnswerQuestionTrackingCommand;

const selectInsert = createUpserter<QuestionState>((id) => defaultQuestionState(id));

export function questionStateReducer(state: QuestionsState, command: QuestionCommand) {
  switch (command.name) {
    case 'answer-question':
      const payload = command.payload.question;
      return selectInsert(state, payload.id, (item) => ({
        id: item.id,
        attempts: [
          ...item.attempts,
          {
            timestamp: payload.timestamp,
            response: payload.response,
            score: payload.score,
            durationSeconds: payload.durationSeconds
          }
        ]
      }));
  }
}
